import { ContactStatusTypes } from './../config/contact-status-types';

/*
 * The contacts statuses module
 */
export default {
  namespaced: true,
  state: {
    statuses: [],
    error: null,
    isLoading: null,
  },

  mutations: {
    setStatuses(state, payload) {
      const removeStatus = {
        id: 0,
        name: 'Remove Status',
        description: 'Removes the status from the selected contact(s)',
      };
      state.statuses = [removeStatus, ...payload];
    },
    setIsLoading(state, payload) {
      state.isLoading = payload;
    },
    setStatusError(state, payload) {
      state.error = payload;
    },
  },

  actions: {
    findStatuses({ commit }) {
      const statuses = ContactStatusTypes;
      commit('setStatuses', statuses);
      commit('setIsLoading', false);
    },
  },
};
